module.exports = __webpack_public_path__ + "img/bsc-logo.0d393996.svg";